import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.assign";
import { storeGroup, getJobs, updateJobs, getGroup, getGroupSettings, updateEmails, updateGroup, removeOrArchiveGroup, unarchive, getGroupRoles } from "src/models/Group";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';; // Init state

var initState = function initState() {
  return {
    organizationGroups: [],
    group: null,
    loading: {
      jobs: false,
      groupSettings: false
    },
    jobs: [],
    emails: [],
    groupRoles: []
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setGroupsLoading: function setGroupsLoading(state, payload) {
    state.loading.groups = payload;
  },
  setOrganizationGroups: function setOrganizationGroups(state, payload) {
    state.organizationGroups = payload;
  },
  setGroup: function setGroup(state, payload) {
    state.group = payload; // Sla de geselecteerde groep ID op in LocalStorage

    if (payload && payload.id) {
      LocalStorage.set("selectedGroupId", payload.id);
    } else {
      LocalStorage.remove("selectedGroupId");
    }
  },
  updateGroup: function updateGroup(state, payload) {
    // Merge the properties of the payload object into the group object in the state
    Object.assign(state.group, payload);
  },
  setJobs: function setJobs(state, payload) {
    !_.isEmpty(payload) ? state.jobs = payload : state.jobs = [];
  },
  setEmails: function setEmails(state, payload) {
    !_.isEmpty(payload) ? state.emails = payload : state.emails = [];
  },
  setEmail: function setEmail(state, payload) {
    state.emails[payload.index] = payload.email;
  },
  addJob: function addJob(state, payload) {
    state.jobs.push(payload);
  },
  removeJob: function removeJob(state, job) {
    var index = state.jobs.findIndex(function (item) {
      return item === job;
    });
    state.jobs.splice(index, 1);
  },
  setJobsLoading: function setJobsLoading(state, payload) {
    state.loading.jobs = payload;
  },
  setGroupSettingsLoading: function setGroupSettingsLoading(state, payload) {
    state.loading.groupSettings = payload;
  },
  setGroupRoles: function setGroupRoles(state, payload) {
    state.groupRoles = payload.data.map(function (item) {
      return {
        value: item.group_role,
        label: item.group_role
      };
    });
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  fetchGroup: function fetchGroup(_ref, groupId) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    //getting group before routing.
    commit("Organization/setPageLoading", true, {
      root: true
    });
    return new Promise(function (resolve, reject) {
      getGroup(groupId).then(function (response) {
        dispatch("setGroup", response.data);
        commit("Organization/setPageLoading", false, {
          root: true
        });
        resolve();
      }).catch(function (e) {
        commit("Organization/setPageLoading", false, {
          root: true
        });
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  createGroup: function createGroup(_ref2, request) {
    var commit = _ref2.commit;
    var formData = request.formData,
        organizationId = request.organizationId;
    return new Promise(function (resolve) {
      storeGroup(organizationId, formData).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  setGroup: function setGroup(_ref3, payload) {
    var commit = _ref3.commit;
    var organizations = this.getters["Organization/organizations"];
    var organization = null;

    if (organizations.length > 0) {
      organization = organizations.find(function (org) {
        return org.groups.data.find(function (group) {
          return group.id === payload.id;
        });
      });
    }

    commit("setGroup", payload);
    commit("Organization/setOrganization", organization, {
      root: true
    });
  },
  fetchGroupSettings: function fetchGroupSettings(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;
    commit("setGroupSettingsLoading", true);
    return new Promise(function (resolve, reject) {
      getGroupSettings(state.group.id).then(function (response) {
        commit("setGroupSettingsLoading", false);
        commit("setJobs", response.data.jobs);
        commit("setEmails", response.data.emails);
        resolve();
      }).catch(function (e) {
        commit("setGroupSettingsLoading", false);
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  updateTheGroup: function updateTheGroup(_ref5, request) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return new Promise(function (resolve, reject) {
      updateGroup(state.group.id, request).then(function (response) {
        commit("updateGroup", request);
        resolve(response);
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  deleteOrArchiveGroup: function deleteOrArchiveGroup(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return new Promise(function (resolve, reject) {
      removeOrArchiveGroup(state.group.id).then(function () {
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        console.log(e.response);
        reject();
      });
    });
  },
  unarchiveGroup: function unarchiveGroup(_ref7, groupId) {
    var commit = _ref7.commit,
        state = _ref7.state;
    return new Promise(function (resolve, reject) {
      unarchive(groupId).then(function () {
        commit("Organization/setUnarchiveOrganizationGroup", groupId, {
          root: true
        });
        resolve();
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        console.log(e.response);
        reject();
      });
    });
  },
  fetchJobs: function fetchJobs(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;
    return new Promise(function (resolve, reject) {
      getJobs(state.group.id).then(function (response) {
        commit("setJobs", response.data.jobs);
        resolve();
      }).catch(function (e) {
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  updateTheJobs: function updateTheJobs(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;
    return new Promise(function (resolve, reject) {
      updateJobs(state.group.id, {
        jobs: state.jobs
      }).then(function () {
        resolve();
      }).catch(function (e) {
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  createJob: function createJob(_ref10, payload) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return new Promise(function (resolve, reject) {
      commit("addJob", payload);
      dispatch("updateTheJobs");
    });
  },
  deleteJob: function deleteJob(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return new Promise(function (resolve, reject) {
      commit("removeJob", payload);
      dispatch("updateTheJobs");
    });
  },
  updateTheEmails: function updateTheEmails(_ref12, request) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;
    commit("setEmail", request);
    return new Promise(function (resolve, reject) {
      updateEmails(state.group.id, {
        emails: state.emails
      }).then(function () {
        dispatch("fetchGroupSettings");
        resolve();
      }).catch(function (e) {
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  },
  fetchGroupRoles: function fetchGroupRoles(_ref13) {
    var commit = _ref13.commit;
    return new Promise(function (resolve, reject) {
      getGroupRoles().then(function (response) {
        commit("setGroupRoles", response.data);
        resolve();
      }).catch(function (e) {
        console.error(e);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
        reject();
      });
    });
  }
}; // Getter functions

var getters = {
  group: function group(state) {
    return state.group;
  },
  organizationGroups: function organizationGroups(state) {
    return state.organizationGroups;
  },
  groupsLoading: function groupsLoading(state) {
    return state.loading.meetings;
  },
  groupLoading: function groupLoading(state) {
    return state.loading.group;
  },
  jobs: function jobs(state) {
    return state.jobs;
  },
  jobsLoading: function jobsLoading(state) {
    return state.loading.jobs;
  },
  emails: function emails(state) {
    return state.emails;
  },
  groupSettingsLoading: function groupSettingsLoading(state) {
    return state.loading.groupSettings;
  },
  groupRoles: function groupRoles(state) {
    return state.groupRoles.filter(function (item) {
      return item.value !== "spectator";
    }); //remove spectator in the group settings.
  },
  allGroupRoles: function allGroupRoles(state) {
    return [{
      value: null,
      label: "no_group_role"
    }].concat(_toConsumableArray(state.groupRoles));
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};